<template>
    <div class="modal fade modal-upload" id="modalDelete">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <div class="center-modal">
                        <div class="center-ttl font300 d-flex justify-content-center">
                            <i class="icon-trash-g mr-2 mt-1"></i>
                            <span class="font500 text-pink">{{$t('voucher.delete.confirm')}}</span>
                        </div>

                        <div class="row mt-4 no-gutters">
                            <div class="col-6 pr-2">
                                <button
                                    class="btn btn-pink-53 w-100"
                                    data-dismiss="modal"
                                    data-toggle="modal"
                                    @click="deleteVoucher"
                                >{{$t('button.ok')}}</button>
                            </div>

                            <div class="col-6 pl-2">
                                <button class="btn btn-gray-53 w-100" data-dismiss="modal">{{$t('button.cancel')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import Utils from "@/helpers/utils";
import { Constants } from "@/helpers/constants";

import VoucherService from "@/services/module/voucher.service";

export default {
    name: "PcDeleteVoucher",
    props: {
        id: "",
        groupType: "",
        getCashDetails: { type: Function },
        listVouchers: { type: Function },
        setErrorMessage: { type: Function },
        reset: { type: Function },
    },
    components: {},
    data () {
        return {};
    },
    beforeMount () {
        this.setErrorMessage("");
    },
    methods: {
        deleteVoucher () {
            VoucherService.remove(this.id)
                .then(response => {
                    $("#modalDelete").modal("hide");
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let msg = this.$root.$t("fail.delete_fail");

                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            msg = this.$t('error.error_code_' + errorCode);
                            this.setErrorMessage(msg);
                        }

                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    } else {
                        this.reset("");
                        this.setErrorMessage("");
                        let msg = this.$root.$t("success.delete_success");

                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            msg = this.$t('error.error_code_' + errorCode);
                            this.setErrorMessage(msg);
                            this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                        } else {
                            this.$toasted.success(msg, {icon: 'fa-check'});
                        }

                        if (this.groupType != Constants.GroupVoucherType.cash_detail) {
                            this.listVouchers();
                        } else {
                            this.getCashDetails();
                        }
                    }
                }).catch(error => {
                    $("#modalDelete").modal("hide");
                    this.setErrorMessage(this.$root.$t("error.error_unknown"));
                    let msg = this.$root.$t("fail.delete_fail");
                    this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/DeleteVoucher.vue